<template>
  <div class="footer">
    <div class="footer__first leading-8">
      <h3 class="leading-8 font-bold">Contact Us</h3>
      <div>
        <p class="leading-8">
          <a href="mailto:sts@thegoldgem.com">sts@thegoldgem.com</a>
        </p>
        <p class="leading-8">+447506428909</p>
        <p class="leading-8">Piccadilly business centre</p>
        <p class="leading-8">Unit C Aldow Enterprise Park</p>
        <p class="leading-8">Blackett Street, Manchester</p>
        <p class="leading-8">M12 6AE</p>
      </div>
    </div>
    <div class="footer__second">
      <h3 class="my-4 font-bold leading-8 ">Follow Us On</h3>
      <div class="footer__second--social">
        <a
          target="_blank"
          href="https://www.facebook.com/STS-Trading-Services-102209611599949/"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="70"
            height="70"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g transform>
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,172v-172h172v172z" fill="none" />
                <path d fill="none" />
                <g fill="#ffffff">
                  <path
                    d="M34.9375,16.125c-10.37207,0 -18.8125,8.44043 -18.8125,18.8125v102.125c0,10.37207 8.44043,18.8125 18.8125,18.8125h102.125c10.37207,0 18.8125,-8.44043 18.8125,-18.8125v-102.125c0,-10.37207 -8.44043,-18.8125 -18.8125,-18.8125zM34.9375,21.5h102.125c7.42212,0 13.4375,6.01538 13.4375,13.4375v102.125c0,7.42212 -6.01538,13.4375 -13.4375,13.4375h-29.83545v-35.01099h15.88354c1.31226,0 2.43555,-0.94482 2.65601,-2.24658l3.05493,-18.68652c0.26245,-1.6377 -0.99732,-3.12842 -2.65601,-3.12842h-18.93848v-4.34619c0,-5.10205 1.0603,-7.38013 7.32764,-7.38013h12.50317c1.48022,0 2.6875,-1.19678 2.6875,-2.6875v-19.46338c0,-1.38574 -1.03931,-2.53003 -2.41455,-2.66651c-3.99976,-0.39892 -11.92578,-1.13379 -15.64209,-1.13379c-17.30078,0 -28.4707,11.90479 -28.4707,30.32886v7.34863h-16.03052c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v18.68652c0,1.49072 1.20728,2.6875 2.6875,2.6875h16.02002v35.01099h-48.27002c-7.42212,0 -13.4375,-6.01538 -13.4375,-13.4375v-102.125c0,-7.42212 6.01538,-13.4375 13.4375,-13.4375zM32.25,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM45.6875,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM59.125,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM72.5625,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM86,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM99.4375,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM112.875,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM126.3125,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM139.75,32.25c-1.49072,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.19678,2.6875 2.6875,2.6875c1.49072,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.19678,-2.6875 -2.6875,-2.6875zM111.68872,59.125c4.11523,0 8.36694,0.24146 12.68164,0.72436v14.47681h-9.80518c-11.39038,0 -12.70264,7.27515 -12.70264,12.75513v9.72119h21.14307l-2.18359,13.31152h-18.96997v40.38599h-13.26953v-40.38599h-18.70752v-13.31152h18.71802v-12.72363c0,-15.62109 8.62939,-24.95386 23.0957,-24.95386z"
                  />
                </g>
              </g>
            </g>
          </svg>
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/ststradingservices/?hl=en"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="70"
            height="70"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g transform>
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,172v-172h172v172z" fill="none" />
                <path d fill="none" />
                <g fill="#ffffff">
                  <path
                    d="M34.9375,16.125c-10.37207,0 -18.8125,8.44043 -18.8125,18.8125v102.125c0,10.37207 8.44043,18.8125 18.8125,18.8125h102.125c10.37207,0 18.8125,-8.44043 18.8125,-18.8125v-102.125c0,-10.37207 -8.44043,-18.8125 -18.8125,-18.8125zM34.9375,21.5h102.125c7.41162,0 13.4375,6.02588 13.4375,13.4375v102.125c0,7.41162 -6.02588,13.4375 -13.4375,13.4375h-102.125c-7.41162,0 -13.4375,-6.02588 -13.4375,-13.4375v-102.125c0,-7.41162 6.02588,-13.4375 13.4375,-13.4375zM129,34.9375c-4.44067,0 -8.0625,3.62183 -8.0625,8.0625c0,4.44067 3.62183,8.0625 8.0625,8.0625c4.44067,0 8.0625,-3.62183 8.0625,-8.0625c0,-4.44067 -3.62183,-8.0625 -8.0625,-8.0625zM129,39.05273c2.1731,0 3.94727,1.77417 3.94727,3.94727c0,2.1731 -1.77417,3.94727 -3.94727,3.94727c-2.1731,0 -3.94727,-1.77417 -3.94727,-3.94727c0,-2.1731 1.77417,-3.94727 3.94727,-3.94727zM86,48.375c-20.74414,0 -37.625,16.88086 -37.625,37.625c0,20.74414 16.88086,37.625 37.625,37.625c20.74414,0 37.625,-16.88086 37.625,-37.625c0,-20.74414 -16.88086,-37.625 -37.625,-37.625zM86,53.75c17.78369,0 32.25,14.46631 32.25,32.25c0,17.78369 -14.46631,32.25 -32.25,32.25c-17.78369,0 -32.25,-14.46631 -32.25,-32.25c0,-17.78369 14.46631,-32.25 32.25,-32.25zM86,59.125c-14.82324,0 -26.875,12.05176 -26.875,26.875c0,14.82324 12.05176,26.875 26.875,26.875c14.82324,0 26.875,-12.05176 26.875,-26.875c0,-14.82324 -12.05176,-26.875 -26.875,-26.875zM86,64.5c11.85229,0 21.5,9.64771 21.5,21.5c0,11.85229 -9.64771,21.5 -21.5,21.5c-11.85229,0 -21.5,-9.64771 -21.5,-21.5c0,-11.85229 9.64771,-21.5 21.5,-21.5zM32.25,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM45.6875,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM59.125,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM72.5625,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM86,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM99.4375,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM112.875,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM126.3125,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875zM139.75,131.6875c-1.48022,0 -2.6875,1.20728 -2.6875,2.6875v5.375c0,1.48022 1.20728,2.6875 2.6875,2.6875c1.48022,0 2.6875,-1.20728 2.6875,-2.6875v-5.375c0,-1.48022 -1.20728,-2.6875 -2.6875,-2.6875z"
                  />
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
  height: 300px;
  background-color: #404c60;
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  height: auto;
}
.footer__first,
.footer__second {
  color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  width: 50%;
}
.footer__first,
.footer__second p {
  line-height: 0;
}

.footer__first,
.footer__second h3 {
  line-height: 0;
}

.footer__first a {
  color: white;
  text-decoration: none;
}

.footer__second--social {
  display: flex;
  justify-content: center;
}

@media only screen and (max-width: 750px) {
  .footer {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
  .footer__first,
  .footer__second {
    box-sizing: border-box;
    width: 100%;
  }
}
</style>
